import * as types from "./mutation-types";
import * as marketplaceService from "../marketplace.service";

export const setListMode = ({ commit }) => {
  commit(types.SET_LIST_MODE);
};

export const setMarketplaceByFilters = ({ commit }, payload) => {
  commit(types.SET_MARKETPLACE_BY_FILTERS, payload);
};

export const getMarketplace = ({ commit, state }, { param, account_id, extension_id, category_group }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const pagination = param === "reset_filter" ? 1 : state.page;
      if (category_group) {
        const response = await marketplaceService.getCategoryMarketplace(category_group, account_id, pagination);
        if (pagination === 1) {
          commit(types.CLEAR_MARKETPLACE);
        }
        commit(types.SET_MARKETPLACE, response);
        resolve(response);
      } else if (
        param &&
        // && param !== "reset_filter"
        extension_id
      ) {
        const response = await marketplaceService.getPartnerMarketplace(param, account_id, extension_id);

        commit(types.SET_PARTNER_INFO, response.partner_info);

        commit(types.SET_MARKETPLACE, response.products);
        resolve(response);
      } else {
        const response = await marketplaceService.getMarketplace(param === "reset_filter" ? 1 : state.page);

        commit(types.SET_PARTNER_INFO, null);
        if (pagination === 1) {
          commit(types.CLEAR_MARKETPLACE);
        }
        commit(types.SET_MARKETPLACE, response);
        resolve(response);
      }
    } catch (error) {
      if (error.data.partner_info) {
        commit(types.SET_PARTNER_INFO, error.data.partner_info);
      }
      reject(error);
    }
  });
};

export const getMarketplaceSearch = ({ commit, state, rootGetters }) => {
  const accountId = rootGetters["accountTypes/getSelectedAccount"].account_id;
  return new Promise(async (resolve, reject) => {
    try {
      const response = await marketplaceService.getMarketplaceSearch(accountId, state.query);
      commit(types.SET_MARKETPLACE_SEARCH_LIST, response);
      resolve(response);
    } catch (error) {
      /* error */
      // console.log("ERROR", error);
      reject(error);
    }
  });
};

export const getMarketplaceInputSearch = ({ commit, state, rootGetters }, payload) => {
  const accountId = rootGetters["accountTypes/getSelectedAccount"].account_id;
  let query = state.query;
  return new Promise(async (resolve, reject) => {
    try {
      let chars;
      let list_strategy = [];
      query = "";

      if (payload.length < 3) {
        return resolve([]);
      }

      chars = "&chars=" + payload;

      query = chars;

      commit(types.SET_MARKETPLACE_SEARCH, query);

      const response = await marketplaceService.getMarketplaceSearch(accountId, state.query);
      commit(types.SET_MARKETPLACE_SEARCH_LIST, response);
      response.forEach((item) => {
        item.strategies.forEach((e) => {
          list_strategy.push(e.strategy_name);
        });
      });

      list_strategy = list_strategy.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
      resolve(list_strategy);
    } catch (error) {
      reject();
    }
  });
};

export const setSearchChars = ({ commit }, payload) => {
  commit(types.SET_SEARCH_CHARS, payload);
};

export const setPartnerSearchTerm = ({ commit }, payload) => {
  commit(types.SET_PARTNER_SEARCH_TERM, payload);
};

export const orderMarketplace = ({ commit, state, rootGetters }, payload) => {
  let query = state.query;

  return new Promise(async (resolve, reject) => {
    try {
      let type;
      let criterion;

      if (payload.type.length > 0) {
        if (payload.type == "asc" || payload.type == "desc") {
          type = "&type=" + payload.type;
        }

        if (payload.criterion) {
          criterion = payload.criterion;
        }

        if (type != undefined) {
          let list_query = query.split("&");

          if (payload.type == "asc") {
            let symbolIndex = list_query.findIndex((x) => x.includes("desc"));

            if (symbolIndex != -1) {
              query = list_query.join("&");
              query = query.replace("desc", "asc");
            } else {
              query += type;
            }
          } else {
            let symbolIndex = list_query.findIndex((x) => x.includes("asc"));

            if (symbolIndex != -1) {
              query = list_query.join("&");
              query = query.replace("asc", "desc");
            } else {
              query += type;
            }
          }
        }

        if (criterion != undefined) {
          let e = ["alpha", "return", "profit_factor", "drawdown", "win_ratio"];

          e.splice(
            e.findIndex((x) => x == criterion),
            1
          );

          let clone_query = query.split("&");

          var posCriterion = -1;
          clone_query.forEach((item, index) => {
            if (e.some((y) => item.includes(y))) {
              posCriterion = index;
            }
          });

          if (posCriterion != -1) {
            clone_query.splice(posCriterion, 1);
          }
          query = clone_query.join("&");
          query += "&criterion=" + criterion;
        }

        let arrayQuery = query.split("&");

        arrayQuery = arrayQuery.filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        });

        query = arrayQuery.join("&");

        // console.log("QUERY RESULT ------------>", query);

        commit(types.SET_MARKETPLACE_SEARCH, query);

        const accountId = rootGetters["accountTypes/getSelectedAccount"].account_id;
        const response = await marketplaceService.getMarketplaceSearch(accountId, state.query);
        commit(types.SET_MARKETPLACE_SEARCH_LIST, response);
        resolve();
      } else {
        // console.log("ZERADO");
        reject();
        return;
      }
    } catch (error) {}
  });
};

export const getFavorite = ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await marketplaceService.getFavorite();
      let favorites = [];
      let data_favorite = [];
      if (response.length > 0) {
        response.forEach((element) => {
          favorites.push(element.pref_data);
        });

        data_favorite = JSON.parse(favorites);
      } else {
        data_favorite = [];
      }

      commit(types.SET_MARKETPLACE_FAVORITE, data_favorite);

      resolve();
    } catch (error) {
      commit(types.SET_MARKETPLACE_FAVORITE, []);
      reject(error);
    }
  });
};

export const postFavorite = ({ commit, state }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let c;
      let new_favorite = payload.favorite;
      let params;

      c = new_favorite.some((x) => x == payload.id_favorite);

      if (c) {
        new_favorite = new_favorite.filter(function (item) {
          return item != payload.id_favorite;
        });
      } else {
        new_favorite.push(payload.id_favorite);
      }

      new_favorite = new_favorite.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });

      params = {
        pref_type: "marketplace",
        pref_data: String("[" + new_favorite + "]"),
      };

      const response = await marketplaceService.postPreference(params);

      let data_favorite = [];

      data_favorite = JSON.parse(response.pref_data);

      commit(types.SET_MARKETPLACE_FAVORITE, data_favorite);

      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const getMarketplaceFavorite = ({ commit, state }, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await marketplaceService.getFavoriteMarketplace();

      let result = response.msg == "Nenhuma preferência encontrada" ? [] : response;
      commit(types.SET_MARKETPLACE_FAVORITE_LIST, result);
      resolve(response);
    } catch (error) {
      // reject(error);
    }
  });
};

export const resetMarketplace = ({ commit }, payload) => {
  commit(types.SET_MARKETPLACE_RESET);
};

export const favoriteClear = ({ commit }) => {
  commit(types.SET_MARKETPLACE_FAVORITE_LIST, []);
};

export const setRangeFilter = ({ commit }, payload) => {
  commit(types.SET_RANGE_FILTER, payload);
};

export const setToggleFilter = ({ commit }, payload) => {
  commit(types.SET_TOGGLE_FILTER, payload);
};

export const clearActiveFilters = ({ commit }, payload) => {
  commit(types.CLEAR_ACTIVE_FILTERS, payload);
};

export const clearFilter = ({ commit }, payload) => {
  commit(types.CLEAR_FILTER, payload);
};
